<script>
  import ButtonSmall from '../ButtonSmall.svelte';

  export let value;
</script>

<div class='game-small-score'>
  {#if ![undefined, null].includes(value.score.visitor) && ![undefined, null].includes(value.score.home)}
    <div class='game-small-score-visitor'>
      {value.score.visitor}
    </div>

    <div class='game-small-score-colon'> : </div>

    <div class='game-small-score-home'>
      {value.score.home}
    </div>
  {:else}
    <div class='game-small-score-play-by-play'>
      <ButtonSmall icon='sports_baseball' link={value.playByPlay} color='green' prepend='Play by play'/>
    </div>

    <div class='game-small-score-space'/>

    <div class='game-small-score-stream'>
      <ButtonSmall icon='live_tv' link={value.stream} color='red' append='Stream'/>
    </div>
  {/if}
</div>

<style>
  .game-small-score {
    display: flex;
    justify-content: center;
  }

  .game-small-score {
    display: flex;
  }

  .game-small-score-visitor, .game-small-score-home {
    display: flex;
    justify-content: center;
    align-items: center;

    width: calc(20px / 3 * 4);
    height: 20px;

    font-family: var(--font-secondary);
    font-weight: 550;
  }

  .game-small-score-colon {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    font-family: var(--font-secondary);
    font-weight: bold;
  }

  .game-small-score-play-by-play, .game-small-score-stream {
    width: calc((100% - 20px) / 2);
  }

  .game-small-score-space {
    width: 20px;
  }
</style>
